/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-01-12 13:49:58
 * @LastEditors: K
 * @LastEditTime: 2022-11-03 11:50:00
 */
// ZDFY(1, "自动发药"), PSGL(2, "皮试管理"), GBXGJG(3,"关闭修改价格"),
// GBKDYSTX(4,"关闭开单医生提醒"), ZDRJSJ(5,"指定日结时间"),
// JZRQSD(6,"结转日期设定"), MRZFFS(7,"默认支付方式");

export enum Checks {
  Zdfy = 1,
  Psgl = 2,
  Gbxgjg = 3,
  Gbkdysstx = 4,
  Zdrjsj = 5,
  Jzrqsd = 6,
  Mrzffs = 7,
  Zjjs = 8,
  Lkcky = 9,
  LKSC = 10,
  ZNFZ = 11,
  QF = 16,
  DZQM = 30,
  ZNSF = 29,
  CFJDYCFJE = 28, // 处方笺是否打印处方金额
  CFJDYBZ = 35, //处方笺打印备注
  GJBL =51,//高级病历开关
  WXGZH =133,//微信公众号
  SYD = 132,//省异地
  DZBBLCFBJZDY = 136, //定制版病历/处方 背景自定义
  FJSCDXZ = 151, //单个附件上传大小限制
  ZYTFF = 176, //中药贴敷方
  YDCFZXSQ = 170,//康久互联网医院
  XFMS = 178, //续费模式
}

export const CheckOptions = [
  Checks.Zdfy,
  Checks.Psgl,
  Checks.Gbxgjg,
  Checks.Gbkdysstx,
  Checks.Zdrjsj,
  Checks.Jzrqsd,
  Checks.Mrzffs,
  Checks.ZNFZ,
  Checks.QF,
  Checks.DZQM,
  Checks.ZNSF,
  Checks.GJBL,
]

export const CheckNames = [
  '自动发药',
  '皮试管理',
  '关闭修改价格(医生)',
  '关闭开单医生提醒',
  '指定日结时间',
  '结转日期设定',
  '默认支付方式',
  '零库存开药',
]

export function getCheckName(check: Checks): string {
  if (check < 0 || check >= CheckNames.length) {
    return ''
  }
  return CheckNames[check]
}

export interface Settinglable {
  id?: string
  type: string
  value?: string
  tenentId?: string
}

export class Settings {
  static Registration = class {
    static readonly SkipPrinting = 'settings.registration.printing.skip'
  }

  static Treatment = class {
    // 接诊医生提醒
    static readonly DoNotWarnDoctorMismatch =
      'settings.treatment.do-not-warn-doctor-mismatch'
    // 诊间结算
    static readonly Settlement = 'settings.treatment.settlement'
  }

  static Recipe = class {
    static readonly UseSpecifiedBatch = 'settings.recipe.use-specified-batch'
    static readonly IgnoreStorage = 'settings.recipe.ignore-storage'
    static readonly TcmUseSpecifiedBatch =
      'settings.recipe.tcm-use-specified-batch'
    static readonly TcmIgnoreStorage = 'settings.recipe.tcm-ignore-storage'
    static readonly ChangePrice = 'settings.recipe.change-price'
  }

  static Payment = class {
    static readonly DefautMethod = 'settings.payment.default-method'
  }

  static Printing = class {
    static readonly Preview = 'settings.printing.preview'

    static readonly HasTreatmentTemplate =
      'settings.printing.has-treatment-template'
  }
}

export interface MedicelListValue {
  cityHospitalNb: string
  countryHospitalNb: string
  endTime: string
  id: number
  insuranceCode: string
  insuranceName: string
  isFaceCall: number
  linkPort: string
  recordType: number
  startTime: string
  sysStatus: number
  tenantId: number
  tenantStatus: number
  ybIp: string
  ybMac: string
  yidiHospitalNb: string
}
export interface payListValue {
  cityHospitalNb: string
  countryHospitalNb: string
  endTime: string
  id: number
  insuranceCode: string
  insuranceName: string
  isFaceCall: number
  linkPort: string
  recordType: number
  startTime: string
  sysStatus: number
  tenantId: number
  tenantStatus: number
  ybIp: string
  ybMac: string
  yidiHospitalNb: string
}

export interface insuranceCodeValue {
  createTime: string
  insuranceCode: string
  insuranceName: string
  isFaceCall: number
  linkPort: string
  recordType: number
  status: number
  updateTime: string
}
